<script>
export default {
  components: {},
  data() {
    return {
      currentYear: new Date().getFullYear(),
    }
  },
  computed: {
    getCompanyInfo: function () {
      let cInfo = this.$store.state.appAuth.companyInfo || null
      if (cInfo && cInfo.primary_color){
        document.body.style.backgroundColor = cInfo.primary_color;
      }
      return cInfo
    }
  },
  created: () => {
    document.body.classList.add('authentication-bg');
    document.body.classList.add('authentication-bg-pattern');
  }
}
</script>

<template>
<div>
  <div class="account-pages mt-5 mb-5">
    <div class="container">
      <slot />
    </div>
  </div>
  <footer class="footer footer-alt">
      {{ getCompanyInfo && getCompanyInfo.company_name ? getCompanyInfo.company_name : ''}} &copy; {{ $t('copyright') }} {{ currentYear }}
      <br>{{ getCompanyInfo && getCompanyInfo.git_version ? getCompanyInfo.git_version : ''}}
  </footer>
</div>
</template>
